import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./header.module.scss";
import { connect } from "react-redux";
import {
  setActiveFeature,
  setActiveProject,
  setActiveFilter,
  setAllFilters,
  setActivePage,
  setMapType,
  setBasemap,
  setZoomToNsw,
  setSearchBarVisible,
} from "../../actions/ui";
import {
  selectHoveredFeature,
  selectActivePage,
  selectActiveFeature,
  selectViewingHub,
  selectIsInternal,
  selectMapType,
  selectBasemap,
  selectSearchBarVisible,
  selectSidebarIsOpen,
} from "../../reducers/";
import Search from "../search";
import NSWSvg from "./nsw-svg";
import geojsonConfig from "../../modules/geometryConfigs";
import { colors } from "../../modules/theme";

import { SIDEBAR_WIDTH, SIDEBAR_HANDLE_WIDTH } from "../../modules/theme";

class Header extends Component {
  constructor(props) {
    super();
    this.state = {
      filterBoxOpen: false,
      mapTypeBoxOpen: false,
    };
    this.handleToggleFilterClick = this.handleToggleFilterClick.bind(this);
  }
  handleToggleFilterClick(hub) {
    return e => {
      return this.props.setActiveFilter(hub);
    };
  }
  
  renderMapType() {
    if (!this.props.isInternal) return;
    if (this.state.mapTypeBoxOpen === false) {
      return (
        <button
          className={`${styles.headerButton} ${styles.filterButton}`}
          onClick={() => this.setState({ mapTypeBoxOpen: true })}
        >
          <span>Map Type</span>
        </button>
      );
    }
    const mapTypeItems = Object.keys(geojsonConfig).map(mapType => {
      const name = geojsonConfig[mapType].displayName;
      return (
        <div key={mapType} className={styles.filterItem}>
          <button
            onClick={() => this.props.setMapType(mapType)}
            data-active={this.props.mapType === mapType}
            disabled={this.props.mapType === mapType}
            className={styles.mapTypeButton}
          >
            {name}
          </button>
        </div>
      );
    });
    return (
      <div className={styles.filters}>
        <div className={styles.filtersHeader}>
          <span>Map Type</span>
          <button
            onClick={() => this.setState({ mapTypeBoxOpen: false })}
            className={styles.filterCloseButton}
          >
            &times;
          </button>
        </div>
        {mapTypeItems}
      </div>
    );
  }

  renderActiveFeatureName() {
    if (this.props.activeFeature || this.props.hoveredFeature) {
      // Hovered feature takes precedence
      const featureToDisplayInLabel =
        this.props.hoveredFeature || this.props.activeFeature;
      return (
        <p
          className={`${styles.activeFeatureName} ${
            this.props.sidebarIsOpen
              ? styles.searchIconGoesRight
              : styles.searchIconGoesLeft
          }`}
          style={{
            border: `1px solid ${colors.darkGreen}`,
            color: colors.darkGreen,
          }}
        >
          {this.props.nameSelector(featureToDisplayInLabel)}
        </p>
      );
    }
    if (this.props.activePage === "map") return null;
    return "NSW";
  }

  renderContent() {
    return (
      <div className={styles.header} style={{ width: `100%` }}>
        <div className={styles.left}>
          <button
            className={`${styles.searchButton} ${
              this.props.sidebarIsOpen
                ? styles.searchIconGoesRight
                : styles.searchIconGoesLeft
            }`}
            style={{ backgroundColor: colors.darkGreen }}
            onClick={() => this.props.setSearchBarVisible(true)}
          >
            <img src={`/img/search-icon-white.svg`} alt="search icon" />
          </button>
          {this.renderActiveFeatureName()}
        </div>
        <div className={styles.right}>
          <button
            className={`${styles.headerButton} ${styles.nswButton}`}
            onClick={() => {
              this.props.setActiveFeature(null);
              this.props.setActiveProject(null);
              this.props.setZoomToNsw(Date.now());
            }}
          >
            <NSWSvg />
          </button>
          {this.renderMapType()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        {this.props.searchBarVisible ? (
          <div
            className={styles.searchContainer}
            style={{
              marginLeft: this.props.sidebarIsOpen
                ? SIDEBAR_WIDTH + 20
                : SIDEBAR_HANDLE_WIDTH + 20,
              marginRight: 20,
              paddingTop: "20px",
            }}
          >
            <div className={styles.search}>
              <Search geometryConfig={this.props.geometryConfig} />
            </div>
          </div>
        ) : (
          <div>{this.renderContent()}</div>
        )}
      </div>
    );
  }
}

Header.propTypes = {
  nameSelector: PropTypes.func.isRequired,
  setSearchBarVisible: PropTypes.func.isRequired,
  setActiveFilter: PropTypes.func.isRequired,
  setActiveFeature: PropTypes.func.isRequired,
  setActiveProject: PropTypes.func.isRequired,
  activePage: PropTypes.string.isRequired,
  activeFeature: PropTypes.object,
  hoveredFeature: PropTypes.object,
  isInternal: PropTypes.bool.isRequired,
  searchBarVisible: PropTypes.bool.isRequired,
  mapType: PropTypes.string.isRequired,
  setMapType: PropTypes.func.isRequired,
  geometryConfig: PropTypes.object.isRequired,
  setZoomToNsw: PropTypes.func.isRequired,
  sidebarIsOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = s => ({
  activePage: selectActivePage(s),
  activeFeature: selectActiveFeature(s),
  hoveredFeature: selectHoveredFeature(s),
  viewingHub: selectViewingHub(s),
  isInternal: selectIsInternal(s),
  mapType: selectMapType(s),
  basemap: selectBasemap(s),
  searchBarVisible: selectSearchBarVisible(s),
  sidebarIsOpen: selectSidebarIsOpen(s),
});
const mapDispatchToProps = {
  setActiveFeature,
  setActiveFilter,
  setActivePage,
  setMapType,
  setBasemap,
  setZoomToNsw,
  setSearchBarVisible,
  setActiveProject,
  setAllFilters,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js